exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MapV2-574d235e{height:100%;position:relative}\n", ""]);

// Exports
exports.locals = {
	"MapV2": "MapV2-574d235e"
};